/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
`
export default class TimerIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" css={Color}>
        <g id="그룹_5488" data-name="그룹 5488" transform="translate(-2174 3583)">
          <path id="패스_5253" data-name="패스 5253" d="M2.7,3.866c.01.011.014.026.024.036A.832.832,0,1,0,3.872,2.7c-.005-.006-.011-.016-.016-.02C.484,0,.277,0,.2,0H.122L.058.057C-.091.2-.166.277,2.673,3.849,2.678,3.855,2.689,3.86,2.7,3.866Z" transform="matrix(0.875, 0.485, -0.485, 0.875, 2177.424, -3583)" fill="#eee"/>
          <path id="패스_5254" data-name="패스 5254" d="M1097.308,1384.943a.619.619,0,0,0-.269-.062.635.635,0,0,0-.542.306.771.771,0,0,0,.267,1.043.731.731,0,0,0,.1.05,3.781,3.781,0,0,1,1.417,5.048,3.621,3.621,0,0,1-3.19,1.939,3.565,3.565,0,0,1-1.741-.459,3.789,3.789,0,0,1-1.646-4.612.689.689,0,0,0,.07-.507.718.718,0,0,0-.313-.449.669.669,0,0,0-.368-.116.646.646,0,0,0-.553.314l-.009.014-.012.025a5.188,5.188,0,0,0,2.564,6.76,4.857,4.857,0,0,0,2.009.435,5,5,0,0,0,4.578-3.067A5.178,5.178,0,0,0,1097.308,1384.943Z" transform="translate(1083.901 -4967.673)" fill="#eee"/>
        </g>
      </svg>
    )
  }
}
